import React, { useState } from 'react';

import { graphql, useStaticQuery, Link } from 'gatsby';
import { useLocation } from '@reach/router';

import { FiArrowRight } from 'react-icons/fi';

import Tool from 'components/tool/Tool';
import imageUrlFor from 'helpers/image-url';

const query = graphql`
  query MainQuery {
    allSanityCollection(
      filter: { showOnHomepage: { eq: true } }
      sort: { fields: position, order: ASC }
    ) {
      nodes {
        slug {
          current
        }
        id
        name
        image {
          asset {
            url
          }
        }
      }
    }
    allSanityTool(sort: { fields: position, order: ASC }) {
      nodes {
        slug {
          current
        }
        id
        name
        logo {
          asset {
            url
          }
        }
        description
      }
    }
  }
`;

const getCollectionWidth = width => {
  if (width >= 1600) return 450;
  if (width >= 1280) return 380;
  if (width >= 992) return 300;
  if (width >= 768) return 340;
  if (width >= 340) return 460;
  return 300;
};

const building = typeof window === 'undefined';

const Main = () => {
  const data = useStaticQuery(query);

  const { pathname } = useLocation();

  const [viewportWidth] = useState(!building && window.innerWidth);

  return (
    <main className="main">
      <div className="collections">
        {data?.allSanityCollection.nodes.map(({ name, image, slug }) => (
          <Link
            key={`link-${slug.current}`}
            className="item link-card"
            style={
              image && {
                background: image
                  ? `url(${imageUrlFor(image.asset.url)
                    .width(getCollectionWidth(viewportWidth))
                    .url()}) no-repeat center top / cover`
                  : 'none',
              }
            }
            to={`/collection/${slug.current}`}
            state={{ prevPath: pathname }}
          >
            <div className="title">{name}</div>
            <div className="cta">
              View collection
              <FiArrowRight className="arrow" />
            </div>
          </Link>
        ))}
      </div>
      <div className="section">
        <h4 className="heading">Popular</h4>
        <div className="tools">
          {data?.allSanityTool.nodes.map(({ name, description, logo, slug }) => (
            <Tool
              key={`main-tool-${slug.current}`}
              name={name}
              description={description}
              logo={logo}
              path={`/${slug.current}`}
            />
          ))}
        </div>
      </div>
    </main>
  );
};

export default Main;
